import React, { useState } from 'react';
import { FaRobot, FaBook, FaThList, FaUsers } from 'react-icons/fa';
import CopilotTab from './components/CopilotTab';
import MaterialsTab from './components/MaterialsTab';
import TemplatesTab from './components/TemplatesTab';
import CompetitorQATab from './components/CompetitorQATab';
import {
  TechShell,
  TechPageHeader,
  TechTabs,
  StatusPill,
} from '../../styles/techComponents';

const TABS = [
  { id: 'copilot', label: 'Copilot' },
  { id: 'materials', label: 'Biblioteca de materiales' },
  { id: 'templates', label: 'Plantillas' },
  { id: 'competitorQA', label: 'Q&A competidores' },
];

const TAB_ICONS = {
  copilot: FaRobot,
  materials: FaBook,
  templates: FaThList,
  competitorQA: FaUsers,
};

const Messaging = () => {
  const [activeTab, setActiveTab] = useState('copilot');
  const Icon = TAB_ICONS[activeTab];

  return (
    <TechShell>
      <TechPageHeader
        title="Mensajería y Materiales"
        subtitle="La IA arma cada pieza usando lo que pasa en vivo (rivales, noticias, hallazgos y objetivos), y todo queda guardado en tu biblioteca para el equipo."
        dossier="MSG://CONTENT/01"
      >
        <StatusPill>Modo <strong>{activeTab}</strong></StatusPill>
        <StatusPill>Motor <strong>IA</strong></StatusPill>
        <StatusPill>Biblioteca <strong>compartida</strong></StatusPill>
      </TechPageHeader>

      <TechTabs tabs={TABS} active={activeTab} onChange={setActiveTab} />

      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: '0.6rem', color: 'var(--text-disabled)', fontSize: '0.78rem', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.16em', textTransform: 'uppercase' }}>
        {Icon && <Icon />} Sección activa
      </div>

      {activeTab === 'copilot' && <CopilotTab />}
      {activeTab === 'materials' && <MaterialsTab />}
      {activeTab === 'competitorQA' && <CompetitorQATab />}
      {activeTab === 'templates' && <TemplatesTab />}
    </TechShell>
  );
};

export default Messaging;
